module.exports = __webpack_public_path__ + "img/21.449946b7.jpg";